/* istanbul ignore file */
export * from './InspiringSearchPreview';
